<section class="modal-header">
  <span id="video-title"></span>

  <button
    aria-label="Close"
    (click)="closeModal()"
    type="button"
    class="video-modal-close"
  >
    <svg
      class="video-close-icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 18L6 6"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</section>
<div #video style="width: 100%; margin-bottom: -6px"></div>
<p id="mobile-video-title"></p>
